import React, { useState, useEffect, useMemo } from "react";
import clsx from "clsx";

import { Filter } from "@transfr-inc/dashboard-components/forms";
import { useCurrentUser } from "@queries";
import { useOrganizations } from "@queries/organization";

import "./organization-filter.scss";

export function OrganizationFilter({
  onOrganizationSelected,
  placeholder = "Filter by Organization",
  className,
  product,
  professionalLearning,
  orgCode,
}) {
  const defaultOption = { name: "All Organizations" };
  const currentUser = useCurrentUser();
  const effectiveOrgCode = orgCode ?? currentUser?.organizationCode;

  const { data: storeOrganizations = [] } = useOrganizations(effectiveOrgCode, {
    enabled: !!effectiveOrgCode,
  });

  const organizations = useMemo(() => {
    let filtered = storeOrganizations;
    if (product && filtered.length > 0) {
      filtered = filtered.filter((org) => org.products.includes(product));
    }
    if (professionalLearning && filtered.length > 0) {
      filtered = filtered.filter((org) => org.professionalLearning === true);
    }
    return [defaultOption, ...filtered];
  }, [storeOrganizations, product, professionalLearning]);

  return (
    <Filter
      className={clsx("organization-filter small", className)}
      placeholder={placeholder}
      data={organizations}
      clearValue={organizations[0]}
      onFilterSelected={onOrganizationSelected}
      labelKey={"name"}
    ></Filter>
  );
}
